module.exports = __webpack_public_path__ + "img/single-product-48.764cd69.webp";